// region Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { Translate, I18n } from "react-redux-i18n";
import Layout from "../../Layouts/LayoutLogin";
import Constants from "../../AppConstants/Constants";
import Utilities from "../../Helpers/Utilities";
import { Field, reduxForm } from "redux-form";
import { getXsrfToken } from "../../Store/Security/Actions";
import { resetPassword, passwordResetFailed } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { Container } from "../../Components/Common/Container";
// endregion

// region Styles
const CustomRow = styled.div`
    &.row:last-of-type {
        margin-top: 20px;
    }
`;

const Button = styled.button`
    width: 200px !important;
`;
// endregion

class PasswordResetPage extends Component {
    constructor(props) {
        super(props);
        const queryStringParameters = Utilities.getQueryStringParameters(props.location.search);

        this.state = {
            loaded: false,
            receivedSuccessfulResponse: false,
            errorMessage: null
        };

        this.renderTextField = this.renderTextField.bind(this);

        props.toggleBlockingStatus(true);

        fetch(`/Account/PasswordResetInfo?token=${queryStringParameters.token}&email=${queryStringParameters.email}`, {
            method: "GET",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }

                if (res.redirected) {
                    props.history.push(Constants.ENDPOINTS.LOGIN);
                } else {
                    return res.text();
                }
            })
            .then(res => {
                this.setState({ loaded: true });
            })
            .catch(error => {
                error.text().then(res => {
                    this.setState({ loaded: true, errorMessage: res.replace(/"/g, "") });
                });
            });
    }

    componentWillUnmount() {
        const { passwordResetFailed } = this.props;

        passwordResetFailed({});
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = touched && error ? "has-error" : "";

        return (
            <div className={className}>
                <input type={field.type} placeholder={field.placeholder} {...field.input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderErrors() {
        if (this.props.passwordResetStatus.response) {
            const { response: { data } } = this.props.passwordResetStatus;
            if (data) {
                return (
                    <div className="col-xl-6 col-md-8">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, resetPassword, reset, toggleBlockingStatus, location: { search } } = this.props;
        const queryStringParameters = Utilities.getQueryStringParameters(search);

        toggleBlockingStatus(true);

        getXsrfToken(({ token }) => {
            values.__RequestVerificationToken = token;
            values.Token = queryStringParameters.token;
            values.Email = queryStringParameters.email;

            resetPassword(values, () => {
                reset();
                toggleBlockingStatus(false);
                this.setState({ receivedSuccessfulResponse: true });
            });
        });
    }

    render() {
        const { handleSubmit, pristine, submitting } = this.props;
        const { loaded, errorMessage, receivedSuccessfulResponse } = this.state;

        return (
            <Layout>
                <div className="nav-container ">
                    <nav className="bar bar-4 bar--transparent bar--absolute" data-fixed-at="200">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 offset-lg-3 col-md-2 col-md-offset-0 col-4">
                                    <div className="bar__module text-center">
                                        <Link to="#" style={{ cursor: "auto" }}>
                                            <img className="logo logo-light logo-mobile" alt="logo" src={require("../../../Assets/Images/logo-white.png")}/>
                                            <img className="logo logo-light logo-desktop" alt="logo" src={require("../../../Assets/Images/logo-velocitor.png")}/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                <Container>
                    {!loaded &&
                        <div/>
                    }

                    {loaded && errorMessage &&
                    <section className="feature-large height-100">
                        <div className="container pos-vertical-center">
                            {!receivedSuccessfulResponse &&
                            <div>
                                <div className="row justify-content-center">
                                    <div className="col-xl-6 col-md-8">
                                        <h2 className="text-center"><Translate value="passwordReset.title" /></h2>
                                        <p className="lead text-center">{errorMessage}</p>
                                    </div>
                                </div>
                                <div className="row justify-content-center" style={{ marginTop: 20 }}>
                                    <div className="col-12 text-center">
                                        <span className="type--fine-print">
                                            <Link to={Constants.ENDPOINTS.LOGIN}><Translate value="passwordReset.back" /></Link>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </section>
                    }

                    {loaded && !errorMessage &&
                    <section className="feature-large height-100">
                        <div className="container pos-vertical-center">
                            {!receivedSuccessfulResponse &&
                            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                <div className="row justify-content-center">
                                    <div className="col-xl-6 col-md-8">
                                        <h2 className="text-center"><Translate value="passwordReset.title" /></h2>
                                        <p className="lead text-center"><Translate value="passwordReset.description" /></p>

                                        <CustomRow className="row justify-content-center">
                                            <div className="col-10">
                                                <Field
                                                    placeholder={I18n.t("passwordReset.form.field1")}
                                                    name="NewPassword"
                                                    type="password"
                                                    component={this.renderTextField}
                                                />
                                            </div>
                                        </CustomRow>

                                        <CustomRow className="row justify-content-center">
                                            <div className="col-10">
                                                <Field
                                                    placeholder={I18n.t("passwordReset.form.field2")}
                                                    name="ConfirmNewPassword"
                                                    type="password"
                                                    component={this.renderTextField}
                                                />
                                            </div>
                                        </CustomRow>
                                    </div>
                                </div>

                                <div className="row justify-content-center" style={{ marginTop: 20 }}>
                                    {this.renderErrors()}
                                    <div className="col-12 text-center">
                                        <Button type="submit" className="btn btn--primary type--uppercase" disabled={pristine || submitting}><Translate value="passwordReset.btn" /></Button>
                                    </div>
                                    <div className="col-12 text-center">
                                        <span className="type--fine-print">
                                            <Link to={Constants.ENDPOINTS.LOGIN}><Translate value="passwordReset.back" /></Link>
                                        </span>
                                    </div>
                                </div>
                            </form>
                            }

                            {receivedSuccessfulResponse &&
                            <div className="row justify-content-center">
                                <div className="col-xl-8 text-center">
                                    <h2 className="text-center"><Translate value="passwordReset.success.title" /></h2>

                                    <Link to={Constants.ENDPOINTS.LOGIN}>
                                        <Button type="button" className="btn btn--primary type--uppercase"><Translate value="passwordReset.back" /></Button>
                                    </Link>
                                </div>
                            </div>
                            }
                        </div>
                    </section>
                    }
                </Container>
            </Layout>
        );
    }
}

PasswordResetPage.propTypes = {
    getXsrfToken: PropTypes.func,
    resetPassword: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    passwordResetFailed: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    reset: PropTypes.func,
    location: PropTypes.object,
    userInfo: PropTypes.object,
    i18n: PropTypes.object,
    passwordResetStatus: PropTypes.object,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        passwordResetStatus: state.passwordResetStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        resetPassword: resetPassword,
        toggleBlockingStatus: toggleBlockingStatus,
        passwordResetFailed: passwordResetFailed
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.NewPassword) {
        errors.NewPassword = I18n.t("validation.passwordReset.password.required");
    }
    if (!values.ConfirmNewPassword) {
        errors.ConfirmNewPassword = I18n.t("validation.passwordReset.confirmPassword.required");
    }
    if (values.NewPassword && values.ConfirmNewPassword && values.NewPassword !== values.ConfirmNewPassword) {
        errors.ConfirmNewPassword = I18n.t("validation.passwordReset.confirmPassword.match");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "PasswordReset"
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage))
);